import axios from "axios";

export function getLogisticsLsh(param) {
  return axios({
    url: "/api/wldj/logisticslsh",
    method: "get",
    params: param,
  });
}

export function getLogistics(param) {
  return axios({
    url: "/api/wldj/logistics",
    method: "get",
    params: param,
  });
}
